<script>
  import { makeApiRequest } from "../../utils/ajax";

  let { socialProfile, profile } = $props();

  async function deleteSocialProfile() {
    if (!confirm("Are you sure you want to delete this profile?")) return;
    await makeApiRequest(`/api/social_profiles/${socialProfile.id}/delete`);
    location.href = "/dashboard";
  }
</script>

<div
  class="flex flex-col md:flex-row items-start md:items-center justify-between">
  <div class="flex items-center mb-4 md:mb-0">
    <div
      class="h-16 w-16 rounded-full bg-indigo-600 flex items-center justify-center text-white text-2xl font-bold mr-4">
      {#if profile.profile_picture_url && profile.profile_picture_url.includes("socialstrack")}
        <img
          src={profile.profile_picture_url}
          alt="{socialProfile.username}'s profile picture"
          class="h-16 w-16 rounded-lg object-cover" />
      {:else}
        {socialProfile.username.charAt(0).toUpperCase()}
      {/if}
    </div>
    <div class="max-w-md overflow-hidden">
      <h1 class="text-2xl font-bold text-gray-900 flex items-center">
        {socialProfile.username}

        {#if profile.is_verified}
          <span class="ml-2 text-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd" />
            </svg>
          </span>
        {/if}

        {#if profile.is_private}
          <span
            class="ml-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 border border-gray-200 shadow-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3.5 w-3.5 mr-1 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <span class="font-semibold">Private</span>
          </span>
        {/if}
      </h1>
      <p class="text-gray-600 text-sm mt-1 flex items-center">
        <span class="truncate block" title={profile.full_name}>
          {#if profile.full_name}
            {profile.full_name}
          {/if}
        </span>
      </p>
    </div>
  </div>
  <div class="flex space-x-3 flex-shrink-0">
    <button
      onclick={() => deleteSocialProfile()}
      class="cursor-pointer bg-red-100 text-red-600 px-3 py-1.5 rounded-md hover:bg-red-200 transition text-sm font-medium flex items-center whitespace-nowrap">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4 mr-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
      Remove Profile
    </button>
  </div>
</div>
